import axios from 'axios'
import {
    setOfflineMode,
    testApiConnection,
} from '../utils/apiConnectionChecker'

export const getMaintenanceMode = async () => {
    try {
        const data = await testApiConnection('/ajax/maintenance-mode')
        return data
    } catch (error) {
        setOfflineMode(true)
    }
}

export const getMaintenanceModeLink = () => {
    return axios.get('/ajax/maintenance-mode-link')
}
